import { SingleContentBlock } from "eddev/blocks"
import { useAppData } from "eddev/hooks"

export function Header() {
  const header = useAppData((d) => d.templateParts?.siteHeader?.contentBlocks[0]!)

  return <SingleContentBlock block={header} />
}
